import React from 'react';
import { RenderIcon } from './render-icon';
import styles from './index.module.scss';

import cx from 'clsx';

const Icon = ({
  icon = 'QuestionCircleOutlined',
  size,
  bgSize,
  iconSize = '1.2em',
  color,
  bgColor,
  hasBackground,
  containerClassName,
  bgStyle,
  iconStyles,
  ...rest
}) => {
  return hasBackground ? (
    <div
      className={cx(styles.hasBackground, containerClassName)}
      style={{
        '--icon-bg': bgColor,
        '--icon-color': color,
        '--icon-bg-size': bgSize,
        ...bgStyle,
      }}
    >
      <RenderIcon icon={icon} iconSize={iconSize} color={color} style={iconStyles} {...rest} />
    </div>
  ) : (
    <RenderIcon icon={icon} iconSize={iconSize} color={color} style={iconStyles} {...rest} />
  );
};

export default Icon;
